import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import CategoriaService from "@/services/catalogos/CategoriaService";
import SubCategoriaService from "@/services/catalogos/SubCategoriaService";
import UnidadMedidaService from "@/services/catalogos/UnidadMedidaService";
import BancoService from "@/services/catalogos/BancoService";
import CuentaBancariaService from "@/services/catalogos/CuentaBancariaService";
import TiendaPosicionService from "@/services/catalogos/TiendaPosicionService";
import ClienteService from "@/services/catalogos/ClienteService";
import CentroCostoService from "@/services/catalogos/CentroCostoService";
import FormaPagoService from "@/services/catalogos/FormaPagoService";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import DynamicService from "@/services/commons/DynamicService";



const llenar_tiendas = (context, params) => {
  return TiendaService.fetch(params)
    .then(res => {
      context.commit('TIENDAS', res.data);
    });
};

const proveedores = (context, params) => {
  return ProveedorService.fetch(params)
    .then(res => {
      context.commit('PROVEEDORES', res.data);
    });
};

const activos_fijos = (context, params) => {
  return DynamicService.fetch('af', 'activo', params)
    .then(res => {
      context.commit('ACTIVOS_FIJOS', res.data);
    });
};

const pilotos = (context, params) => {
  return DynamicService.fetch('transporte', 'piloto', params)
    .then(res => {
      context.commit('PILOTOS', res.data);
    });
};

const productos = (context, params) => {
  return ProductosService.fetch(params)
    .then(res => {
      context.commit('PRODUCTOS', res.data);
    });
};

const categorias = (context, params) => {
  return CategoriaService.fetch(params)
    .then(res => {
      context.commit('CATEGORIAS', res.data);
    });
};

const subcategorias = (context, params) => {
  return SubCategoriaService.fetch(params)
    .then(res => {
      context.commit('SUBCATEGORIAS', res.data);
    });
};

const bancos = (context, params) => {
  return BancoService.fetch(params)
    .then(res => {
      context.commit('BANCOS', res.data);
    });
};

const unidades_medidas = (context, params) => {
  return UnidadMedidaService.fetch(params)
    .then(res => {
      context.commit('UNIDADES_MEDIDAS', res.data);
    });
};

const tiendas = (context, params) => {
  return TiendaService.fetch(params)
    .then(res => {
      context.commit('TIENDAS', res.data);
    });
};

const cuentas = (context, params) => {
  return CuentaBancariaService.fetch(params)
    .then(res => {
      context.commit('CUENTAS', res.data);
    });
};

const cuentas_bancarias = (context, params) => {
  return CuentaBancariaService.fetch(params)
    .then(res => {
      context.commit('CUENTAS_BANCARIAS', res.data);
    });
};

const posicion = (context, params) => {
  return TiendaPosicionService.fetch(params)
    .then(res => {
      context.commit('POSICION', res.data);
    });
};

const clientes = (context, params) => {
  return ClienteService.fetch(params)
    .then(res => {
      context.commit('CLIENTES', res.data);
    });
};

const centro_costo = (context, params) => {
  return CentroCostoService.fetch(params)
    .then(res => {
      context.commit('CENTRO_COSTO', res.data);
    });
};

const formas_pago = (context, params) => {
  return FormaPagoService.fetch(params)
    .then(res => {
      context.commit('FORMAS_PAGO', res.data);
    });
};

const lista_precio = (context, params) => {
  return ListaPreciosService.fetch(params)
    .then(res => {
      context.commit('LISTA_PRECIO', res.data);
    });
};



export default {
  llenar_tiendas,
  proveedores,
  pilotos,
  activos_fijos,
  productos,
  categorias,
  subcategorias,
  unidades_medidas,
  bancos,
  tiendas,
  cuentas,
  cuentas_bancarias,
  posicion,
  clientes,
  centro_costo,
  formas_pago,
  lista_precio,
};